import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Switch,Route,Redirect } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import {ScreenHOC} from '../../components/hoc/screen-hoc';
import { makeStyles } from '@material-ui/core/styles';
import { ROUTES, HAMBURGER_ICON, HEADER_LOGO, CLOSE_ICON,STRINGS,STAFF_DRAWER_ITEMS } from '../../shared/constants';
import { DriverScreen } from '../../views/drivers';
import { AgenciesScreen } from '../../views/agencies';
import { ProfileScreen } from '../../views/profile';
import { DecisionPopup } from '../../components/atoms';
import { PromoSettingScreen } from '../../views/promo-setting';
import { PriceSettingScreen } from '../../views/token-setting';
import {setAuthorization,stopLoader,setPlatformType } from '../../redux/actions';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    paper: {
        marginRight: theme.spacing(2),
    },
}));
const StaffRouter = ({
  userData,
  setPlatformType,
  setAuthorization
}) => {
    let history = useHistory()
  const classes = useStyles();
  const [popupVisible,setPopVisible]=useState(false)
    return (
        <ScreenHOC
        containerStyle={classes.screenHocContainer}
        childrenStyle={classes.screenContentContainer}
        drawerItems={STAFF_DRAWER_ITEMS}
        userData={userData}
        headerMenuItem={['Profile','Logout']}
        onClickAction={(changedUrl) => {
          if (changedUrl === ROUTES.LOGOUT) {
            setPopVisible(true);

          }
          else {
            history.push(changedUrl);
          }
        }}
        hamburgerIcon={HAMBURGER_ICON}
        headerLogo={HEADER_LOGO}
        headerLogoAction={() => {
          history.replace(ROUTES.PROFILE)
        }}
        profileLogoClick={() => {
          history.replace(ROUTES.PROFILE)
        }}
        backArrow={CLOSE_ICON}
      >
        <DecisionPopup
          modalVisibility={popupVisible}
          dialogContent={STRINGS.LOGOUT_CONTENT}
          dialogTitle={STRINGS.LOGOUT}
          confirmButtonTitle={STRINGS.CONFIRM}
          rejectButtonTitle={STRINGS.CANCEL}
          toggleDialogModal={() => setPopVisible(!popupVisible)}
          onConfirmation={() => {
            setAuthorization(null);
            setPlatformType(null);
            history.push(ROUTES.LOGIN)
          }}
          onRejection={() => setPopVisible(false)}
        />
            <Switch>
                <Route exact path={ROUTES.DRIVERS} render={() => { return <DriverScreen /> }} />
                <Route exact path={ROUTES.AGENCIES} render={() => { return <AgenciesScreen /> }} />
                <Route exact path={ROUTES.PROFILE} render={() => { return <ProfileScreen /> }} />
                <Route exact path={ROUTES.PROMO_SETTING} render={() => { return <PromoSettingScreen /> }} />
                <Route exact path={ROUTES.TOKEN_PRICE_SETTING} render={() => { return <PriceSettingScreen /> }} />
                <Redirect to={ROUTES.AGENCIES} />
            </Switch>
       </ScreenHOC>
    );
}

const mapStateToProps = (state) => {
  return ({
    userData: state.CommonReducer.userData,
    userToken: state.CommonReducer.userToken,
    platformType: state.CommonReducer.platformType,
  });
}
const mapDispatchToProps = (dispatch) => {
  return {
    setAuthorization: (userData) => dispatch(setAuthorization(userData)),
    setPlatformType: (platformType) => dispatch(setPlatformType(platformType)),
    stopLoader: () => dispatch(stopLoader()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffRouter);